import { getApiBaseUrl } from './ApiClient';

export function profileImageSource(image, mimeType = 'image/jpeg') {
  if (typeof image === 'string' && image.trim()) {
    const source = image.trim();
    if (/^(https?:|data:image\/|blob:)/i.test(source)) return source;
    if (!/^\/?uploads\//.test(source)) return '';
    const origin = new URL(getApiBaseUrl(), window.location.origin).origin;
    return new URL(`/${source.replace(/^\/+/, '')}`, origin).href;
  }
  // Keep existing binary records readable until their owners replace them.
  if (Array.isArray(image?.data) && image.data.length) {
    let binary = '';
    for (const byte of image.data) binary += String.fromCharCode(byte);
    return `data:${/^image\/(jpeg|png|gif|webp)$/.test(mimeType) ? mimeType : 'image/jpeg'};base64,${btoa(binary)}`;
  }
  return '';
}
